import { IFundingWiresData } from '@common/interfaces/fundingWire'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

export default combineReducers({
  fundingWiresData: createLoadingDataReducer<IFundingWiresData>([
    actions.LIST_OUTGOING_WIRE_REQUEST,
  ]),
})
